<template>
    <div v-show="show">
      <hp5-alert type="info" hide-alert-text :show-alert="true">
        <span class="coverage">Coverage</span> Your insurance will cover up to $160 of your Physical Therapy visit.
        <a target="_blank" href="/fcp/csearch/Reference_Based_Benefits_Provider_List_08.09.21.pdf">Learn more</a>
      </hp5-alert>
    </div>
</template>
  
<script setup>

      const zipCodes = [
        55070,
        55092,
        55079,
        55448,
        55449,
        55303,
        55434,
        55433,
        55432,
        55014,
        55011,
        55304,
        55421,
        55005,
        55394,
        55555,
        55554,
        55553,
        55552,
        55551,
        55550,
        55339,
        55318,
        55556,
        55564,
        55397,
        55399,
        55322,
        55315,
        55388,
        55368,
        55367,
        55594,
        55583,
        55383,
        55360,
        55386,
        55573,
        55560,
        55387,
        55557,
        55568,
        55567,
        55566,
        55562,
        55317,
        55559,
        55558,
        55118,
        55337,
        55122,
        55076,
        55077,
        55121,
        55068,
        55065,
        55044,
        55033,
        55075,
        55031,
        55085,
        55123,
        55124,
        55150,
        55306,
        55024,
        55010,
        55120,
        55375,
        55384,
        55392,
        55402,
        55393,
        55405,
        55374,
        55404,
        55403,
        55401,
        55391,
        55345,
        55111,
        55305,
        55346,
        55311,
        55406,
        55323,
        55327,
        55331,
        55316,
        55343,
        55373,
        55347,
        55348,
        55356,
        55357,
        55359,
        55361,
        55364,
        55369,
        55340,
        55470,
        55446,
        55484,
        55483,
        55480,
        55479,
        55478,
        55474,
        55407,
        55472,
        55487,
        55467,
        55460,
        55459,
        55458,
        55455,
        55454,
        55450,
        55447,
        55473,
        55577,
        55599,
        55598,
        55597,
        55596,
        55595,
        55593,
        55592,
        55485,
        55578,
        55486,
        55576,
        55574,
        55572,
        55571,
        55570,
        55569,
        55488,
        55344,
        55579,
        55417,
        55429,
        55428,
        55427,
        55426,
        55425,
        55445,
        55423,
        55422,
        55420,
        55430,
        55418,
        55424,
        55416,
        55415,
        55414,
        55413,
        55412,
        55411,
        55410,
        55409,
        55408,
        55419,
        55438,
        55444,
        55443,
        55442,
        55441,
        55440,
        55439,
        55437,
        55436,
        55435,
        55431,
        54011,
        54003,
        54010,
        54014,
        54767,
        54761,
        54021,
        54740,
        54723,
        54022,
        54750,
        55102,
        55101,
        55191,
        55119,
        55144,
        55161,
        55146,
        55169,
        55164,
        55133,
        55103,
        55145,
        55165,
        55166,
        55168,
        55155,
        55112,
        55116,
        55170,
        55177,
        55175,
        55114,
        55113,
        55104,
        55172,
        55117,
        55171,
        55110,
        55126,
        55127,
        55109,
        55108,
        55130,
        55107,
        55106,
        55105,
        55372,
        55020,
        55378,
        56011,
        55379,
        55054,
        56071,
        55352,
        54023,
        54025,
        54027,
        54028,
        54082,
        54016,
        54015,
        54017,
        54013,
        54002,
        54007,
        53086,
        53090,
        53095,
        53076,
        53060,
        53022,
        53033,
        53037,
        53017,
        53040,
        53027,
        55090,
        55129,
        55128,
        55125,
        55187,
        55115,
        55188,
        55083,
        55082,
        55042,
        55071,
        55001,
        55055,
        55047,
        55043,
        55038,
        55025,
        55016,
        53002,
        55003,
        55073,
      ]
      const keySpecialties = ['lsp48', 'psp197', 'psp667']
      const { profile, specialties, searchResults } = useFCPModel()
      const zip = computed(() => profile.value.initialZipCode)
      const has3mCoverage = computed(() => profile.value.hasAny3MCoverage)
      const isInRegion = computed(() => {
        const zp = parseInt(zip.value)
        return zipCodes.includes(zp)
      })
      const specialtiesAtSearchTime = ref([])
      const hasAppropriateSpecialty = computed(() => {
        const spec = specialtiesAtSearchTime.value
        for (let i = 0; i < spec.length; i++) {
          const specialty = spec[i]
          if (keySpecialties.includes(specialty)) return true
        }
        return false
      })
  
      const show = computed(() => {
        return profile.value.isAuthenticated && has3mCoverage.value && isInRegion.value & hasAppropriateSpecialty.value
      })
  
      /**
       * Take a snapshot of the list of specialties that were in play during the most recent search.
       * We don't want the alert to show up or hide by observing the specialties in the model since specialties are
       * dyamically updated at runtime when the user updates the term in the criteria, so take a snapshot of the
       * specialties after the search that can be used by the referencedBasedBenefitsAlert to
       * determine whether or not it should be displayed.  We will also transform the specialties a little from their
       * original form so they are more easily comparable to the keySpecialties list.
       */
      const snapshotSpecialties = () => {
        if (specialties.value) {
          const snapshot = specialties.value.map((s) => s.id)
          specialtiesAtSearchTime.value = snapshot
        }
      }
  
      watch(searchResults, () => {
        snapshotSpecialties()
      })
  
</script>
  
<style scoped>
  .coverage {
    font-weight: bold;
  }
</style>